import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import ScrollAnimation from 'react-animate-on-scroll';
import './ContactBlock.scss';
import parse from 'html-react-parser';
import ReactMarkdown from "react-markdown"
import loadable from "@loadable/component";
import Buttons from "../Buttons/Buttons";
import { CONTACTFORM_PAGE_URL } from "@Components/common/site/constants";
const LeafletResultsMap = loadable(() => import("../map/leaflet/results"));

const ContactBlock = (props) => {
    const { ContactTitle, Content, Offices, Image, Ctas, id, ggfx_results ,isModule, officeData } = props
    let hits = []
    Offices && Offices.map((item) => {
        hits.push({
            _geoloc: { lat: item.latitude, lng: item.longitude }
        })
    })

    return (
        <section className={`contact-wrapper-section ${props.image_align === "right" ? "right" : "left"} grey`} >
            <Container>
                <Row className={`d-flex align-items-center ${props.image_align === "right" ? "flex-row-reverse" : ""}`}>
                    <Col lg={6}>
                        <ScrollAnimation animateIn="animate__fadeIn" animateOnce delay={100} offset={10}>
                            <div className="content-wrapper">

                                <h2>{ContactTitle}</h2>
                                {Content && <>{parse(Content)}</>}
                                {isModule === "officedetail" ? (
                                    <div className="office-details">
                                        {/* Address */}
                                        <div className="office office-detail-row">
                                            <div className="name office-detail-label">Office Address</div>
                                            <div className="office-detail-value">
                                                <ReactMarkdown
                                                    source={officeData?.Address}
                                                    allowDangerousHtml
                                                />
                                            </div>
                                        </div>

                                        {/* Opening Hours */}
                                        <div className="office office-detail-row">
                                            <div className="name office-detail-label">Opening Hours</div>
                                            <div className="office-detail-value">
                                                <ReactMarkdown
                                                    source={officeData?.Opening_Hours}
                                                    allowDangerousHtml
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="office-details">
                                        {Offices && Offices.map((item, n) => {
                                            return (
                                                <div className="office" key={n}>
                                                    <div className="name">{item.Name}</div>
                                                    <ul>
                                                        <li><i className="icon-phone"></i><a href={`tel:${item.Phone}`}>{item.Phone}</a></li>
                                                        <li><i className="icon-whatsapp"></i><a href={`https://wa.me/${item.Whatsapp}`}>WhatsApp</a></li>
                                                        <li><i className="icon-mail"></i><Link to={'/contact/'}>{item.Email}</Link></li>
                                                    </ul>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}

                                <Buttons btns={Ctas} />
                            </div>

                        </ScrollAnimation>
                    </Col>
                    <Col lg={1}></Col>
                    <Col lg={5}>
                        {props.Offices && hits.length > 0 && isModule !== "home" && <LeafletResultsMap hits={hits}
                            height={"350px"}
                        />}
                        {isModule === "home" &&
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2374.6807526804846!2d-2.2443833!3d53.4741654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb18ed9a7326f%3A0x5aca7a7cdf9a2b74!2sBentley%20Hurst%20-%20Estate%20Agents%20%26%20Letting%20Agents%20in%20Manchester!5e0!3m2!1sen!2sqa!4v1761630379874!5m2!1sen!2sqa"
                            width="100%"
                            height="350"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                       />}

                        {/* <ScrollAnimation animateIn="animate__slideInUp" animateOnce delay={100} offset={10}>{props.content && <ContentModule Content={props.content?.data?.content} />}</ScrollAnimation>
                        <ScrollAnimation animateIn="animate__slideInUp" animateOnce delay={200} offset={20}>{props.cta_link && <CTALink class="button button-secondary-outline" link={props.cta_link} title={props.cta_title} target_window={props.cta_link.target_window} />}</ScrollAnimation> */}


                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default ContactBlock;